// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OwMp","top":"styles_top__12pYJ"};